<template>
    <div class="changepwd">
        <div class="changepwd-heading">
            <h2>{{getPageTitle()}}</h2>
            <p>{{trans.text.changePassword.passwordRule}}</p>
        </div>

        <div class="changepwd-form">
            <form @submit.prevent="submit()">
                <div class="inp-group" v-if="is_change_password_page()">
                    <label for="pwd1" v-if="!password_error">{{trans.text.changePassword.oldPwd}}</label>
                    <span class="inp-error__text" v-if="password_error">{{password_error}}</span>
                    <input class="inp-style inp-fw" id="pwd1" name="#" type="password"
                           v-model="password">
                </div>

                <div class="inp-group">
                    <label for="pwd2" v-if="!new_password_error && !wrongFormatPassword">{{trans.text.changePassword.newPwd}}</label>
                    <span class="inp-error__text" v-if="new_password_error">{{new_password_error}}</span>
                    <span class="inp-error__text" v-if="wrongFormatPassword">{{trans.text.changePassword.wrongPwd}}</span>
                    <input class="inp-style inp-fw" id="pwd2" name="#" type="password"
                           v-model="new_password">
                </div>

                <div class="inp-group">
                    <label for="pwd3"
                           v-if="!wrongPasswordConfirmation">{{trans.text.changePassword.repeatPwd}}</label>
                    <span class="inp-error__text" v-if="wrongPasswordConfirmation">{{trans.text.changePassword.notSame}}</span>
                    <input class="inp-style inp-fw" id="pwd3" name="#" type="password"
                           v-model="new_password_confirmation">

                </div>

                <button v-if="!showSaveButton" :class="isSaveDisabled ? 'btn-gray disabled' : ''" :disabled="isSaveDisabled"
                        class="btn btn-green btn-submit">{{trans.text.changePassword.save}}
                </button>
            </form>
        </div>

        <div class="changepwd-error">
            <p class="red" v-if="error">{{error}}</p>
        </div>
        <p class="badge badge-success" v-if="success">{{success}}</p>
    </div>
</template>


<script>
    export default {
        props: ['trans'],
        data() {
            return {
                error: '',
                success: '',
                password: '',
                password_error: '',
                new_password: '',
                new_password_error: '',
                new_password_confirmation: '',
                wrongFormatPassword: false,
                wrongPasswordConfirmation: false,
            }
        },
        computed: {
            isSaveDisabled() {
                let validator =this.wrongFormatPassword
                    || this.wrongPasswordConfirmation
                    || this.new_password.length === 0
                    || this.new_password_confirmation.length === 0;
                if (this.is_change_password_page()){
                    return validator || this.password.length === 0;
                }
                return validator;
            },
            showSaveButton(){
                return !!this.error || !!this.success
            }

        },
        methods: {
            getPageTitle(){
                if(this.is_change_password_page()){
                    return this.trans.text.changePassword.title
                }
                if (!!this.trans.text.createPassword){
                    return this.trans.text.createPassword.title
                }
                return 'Create password'
            },
            is_change_password_page(){
                return localStorage.hasOwnProperty('user') &&
                    !!JSON.parse(localStorage.getItem('user')).is_changed_password
            },
            submit() {
                if (this.wrongFormatPassword || this.wrongPasswordConfirmation) {
                    return;
                }
                this.password_error = '';
                this.new_password_error = '';

                if (this.new_password.length === 0) {
                    this.wrongFormatPassword = false;
                } else {
                    this.wrongFormatPassword = this.new_password.length < 8;
                }

                if (this.new_password_confirmation.length === 0) {
                    this.wrongPasswordConfirmation = false;
                } else {
                    this.wrongPasswordConfirmation = this.new_password_confirmation !== this.new_password;
                }

                if (this.wrongFormatPassword || this.wrongPasswordConfirmation) {

                    setTimeout(function () {
                        this.wrongFormatPassword = false;
                        this.wrongPasswordConfirmation = false;
                        this.$store.commit('updatePassError', '');
                    }.bind(this), 5000);

                    return
                }


                axios
                    .post(this.$path + '/updateUserPassword', {
                        'password': this.password,
                        'new_password': this.new_password,
                        'new_password_confirmation': this.new_password_confirmation,
                    }, {
                        headers: {
                            'Content-Type': 'application/json',
                            Authorization: 'Bearer ' + localStorage.getItem('access_token')
                        }
                    })
                    .then(response => {
                        this.clearFields();
                        this.success = response.data.message;

                        setTimeout(function () {
                            this.success = '';

                        }.bind(this), 5000)
                    })
                    .catch(err => {
                        if (err.response.data.errors.password) {
                            this.password_error = err.response.data.errors.password[0]
                            setTimeout(function () {
                                this.password_error = false;
                            }.bind(this), 5000)
                        }
                        if (err.response.data.errors.new_password) {
                            this.new_password_error = err.response.data.errors.new_password[0]
                        }

                    })
            },
            clearFields() {
                this.password = '';
                this.new_password = '';
                this.new_password_confirmation = '';
            }
        },
        watch: {
            new_password: {
                handler: function (password) {
                    this.new_password_error = false;
                }
            },
            new_password_confirmation: {
                handler: function (password) {
                    this.wrongPasswordConfirmation = false;
                }
            }
        }
    }
</script>

<style scoped>
    .btn-submit.disabled {
        cursor: default;
    }
    .btn-submit.disabled:hover{
        background-color: #efefef;
    }
</style>
